<section class="operations-page">

  <header class="page-header">
    <div class="page-header-text">
      <h1 class="page-title">EDC Operations</h1>
      <p class="page-sub">Manufacturing outcomes enabled by EDC data: availability, reliability, effectiveness, and downtime.</p>
    </div>
    <div class="filterbar">
      <span class="filter active">Last 30 Days</span>
      <span class="filter">All Plants</span>
      <span class="filter">All Equipment</span>
    </div>
  </header>

  <!-- KPI Cards -->
  <div class="kpi-grid">
    <article class="kpi-card">
      <span class="kpi-label">OA</span>
      <div class="kpi-value">87.5%</div>
      <div class="kpi-delta kpi-delta--up">▲ 2.1%</div>
    </article>
    <article class="kpi-card">
      <span class="kpi-label">OEE</span>
      <div class="kpi-value">72.1%</div>
      <div class="kpi-delta kpi-delta--up">▲ 1.6%</div>
    </article>
    <article class="kpi-card">
      <span class="kpi-label">MTTR</span>
      <div class="kpi-value">2.45h</div>
      <div class="kpi-delta kpi-delta--up">▼ 0.3h (improving)</div>
    </article>
    <article class="kpi-card">
      <span class="kpi-label">MTBF</span>
      <div class="kpi-value">120h</div>
      <div class="kpi-delta kpi-delta--up">▲ 5h</div>
    </article>
    <article class="kpi-card">
      <span class="kpi-label">Total Downtime</span>
      <div class="kpi-value">18.6K</div>
      <div class="kpi-delta kpi-delta--up">▼ 4.7% (improving)</div>
    </article>
    <article class="kpi-card">
      <span class="kpi-label">20+ Min Events</span>
      <div class="kpi-value">412</div>
      <div class="kpi-delta kpi-delta--bad">▲ 3.2%</div>
    </article>
  </div>

  <!-- KPI Trend chart + Downtime Distribution -->
  <div class="content-grid two-col">

    <article class="panel chart-panel">
      <h3 class="section-title">30-Day KPI Trends</h3>
      <div class="chart-area">
        <svg viewBox="0 0 620 220" aria-label="30-day KPI trend lines">
          <!-- Grid -->
          <line class="chart-axis" x1="35" y1="190" x2="600" y2="190"/>
          <line class="chart-grid" x1="35" y1="148" x2="600" y2="148"/>
          <line class="chart-grid" x1="35" y1="107" x2="600" y2="107"/>
          <line class="chart-grid" x1="35" y1="65" x2="600" y2="65"/>
          <line class="chart-grid" x1="35" y1="23" x2="600" y2="23"/>
          <!-- Y-axis labels -->
          <text class="chart-label" x="30" y="193" text-anchor="end">60%</text>
          <text class="chart-label" x="30" y="151" text-anchor="end">70%</text>
          <text class="chart-label" x="30" y="110" text-anchor="end">80%</text>
          <text class="chart-label" x="30" y="68" text-anchor="end">90%</text>
          <text class="chart-label" x="30" y="26" text-anchor="end">100%</text>
          <!-- OA line (blue) -->
          <polyline class="trend-line" stroke="#2477b5"
            points="35,120 88,111 140,116 193,103 245,98 298,91 350,96 403,81 455,76 508,69 560,65 600,56"/>
          <!-- OEE line (green) -->
          <polyline class="trend-line" stroke="#31a36f"
            points="35,151 88,143 140,137 193,134 245,124 298,119 350,113 403,108 455,101 508,96 560,91 600,85"/>
          <!-- X-axis labels -->
          <text class="chart-label" x="35" y="210" text-anchor="middle">Jun 16</text>
          <text class="chart-label" x="175" y="210" text-anchor="middle">Jun 22</text>
          <text class="chart-label" x="315" y="210" text-anchor="middle">Jun 28</text>
          <text class="chart-label" x="455" y="210" text-anchor="middle">Jul 10</text>
          <text class="chart-label" x="600" y="210" text-anchor="middle">Jul 15</text>
        </svg>
      </div>
      <div class="chart-legend">
        <span class="legend-item"><i class="legend-swatch" style="background:#2477b5"></i> OA</span>
        <span class="legend-item"><i class="legend-swatch" style="background:#31a36f"></i> OEE</span>
      </div>
    </article>

    <article class="panel">
      <h3 class="section-title">Downtime Distribution</h3>
      <div class="donut-wrap" aria-label="Downtime distribution by cause">
        <div class="donut donut--downtime">
          <div class="donut-center">18.6K</div>
        </div>
      </div>
      <div class="chart-legend centered">
        <span class="legend-item"><i class="legend-swatch" style="background:#1769aa"></i> Equipment (44%)</span>
        <span class="legend-item"><i class="legend-swatch" style="background:#ee7c24"></i> Tooling (28%)</span>
        <span class="legend-item"><i class="legend-swatch" style="background:#31a36f"></i> Process (16%)</span>
        <span class="legend-item"><i class="legend-swatch" style="background:#93a7ba"></i> Other (12%)</span>
      </div>
    </article>

  </div>

  <!-- NAMC Outcomes table -->
  <article class="panel module-gap">
    <div class="section-head-row">
      <div>
        <h3 class="section-title">Operational Outcomes by NAMC</h3>
        <p class="muted">Compare across the portfolio or isolate one plant. Lower MTTR is better. Expand a NAMC to see shop-level outcomes.</p>
      </div>
      <div class="filter-pair">
        <label class="select-control">
          Plant / NAMC
          <select aria-label="Select NAMC">
            <option value="ALL">All NAMCs</option>
            <option value="TMMI">TMMI</option>
            <option value="TABC">TABC</option>
            <option value="TMMTX">TMMTX</option>
            <option value="TMMK">TMMK</option>
            <option value="TMMMS">TMMMS</option>
            <option value="TMMC">TMMC</option>
          </select>
        </label>
        <label class="select-control">
          Shop Type
          <select aria-label="Select shop type">
            <option value="ALL">All Shop Types</option>
            <option value="Assembly">Assembly</option>
            <option value="Body Weld">Body Weld</option>
            <option value="Paint">Paint</option>
            <option value="Plastics">Plastics</option>
            <option value="Stamping">Stamping</option>
            <option value="Casting">Casting</option>
            <option value="Other">Other</option>
          </select>
        </label>
      </div>
    </div>
    <div class="table-wrap">
      <table class="data-table">
        <thead>
          <tr>
            <th>NAMC</th>
            <th class="numeric">OA</th>
            <th class="numeric">OEE</th>
            <th class="numeric">MTBF</th>
            <th class="numeric">MTTR</th>
            <th>30-Day Direction</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>TMMI</strong></td>
            <td class="numeric">88.2%</td>
            <td class="numeric">73.4%</td>
            <td class="numeric">124h</td>
            <td class="numeric">2.31h</td>
            <td><span class="pill pill--good">Improving</span></td>
          </tr>
          <tr>
            <td><strong>TABC</strong></td>
            <td class="numeric">91.1%</td>
            <td class="numeric">78.2%</td>
            <td class="numeric">138h</td>
            <td class="numeric">1.92h</td>
            <td><span class="pill pill--good">Improving</span></td>
          </tr>
          <tr>
            <td><strong>TMMTX</strong></td>
            <td class="numeric">84.6%</td>
            <td class="numeric">68.9%</td>
            <td class="numeric">108h</td>
            <td class="numeric">2.78h</td>
            <td><span class="pill pill--warn">Watch</span></td>
          </tr>
          <tr>
            <td><strong>TMMK</strong></td>
            <td class="numeric">87.3%</td>
            <td class="numeric">72.1%</td>
            <td class="numeric">120h</td>
            <td class="numeric">2.36h</td>
            <td><span class="pill pill--info">Stable</span></td>
          </tr>
          <tr>
            <td><strong>TMMMS</strong></td>
            <td class="numeric">85.5%</td>
            <td class="numeric">70.3%</td>
            <td class="numeric">113h</td>
            <td class="numeric">2.57h</td>
            <td><span class="pill pill--info">Stable</span></td>
          </tr>
          <tr>
            <td><strong>TMMC</strong></td>
            <td class="numeric">89.0%</td>
            <td class="numeric">75.6%</td>
            <td class="numeric">130h</td>
            <td class="numeric">2.09h</td>
            <td><span class="pill pill--good">Improving</span></td>
          </tr>
        </tbody>
      </table>
    </div>
  </article>

  <!-- Top Equipment Faults -->
  <article class="panel module-gap">
    <div class="section-head-row">
      <div>
        <h3 class="section-title">Top Equipment Fault Categories</h3>
        <p class="muted">Most frequent fault types across all monitored equipment in the selected scope and date range.</p>
      </div>
    </div>
    <div class="fault-bars">
      <div class="fault-row">
        <span class="fault-label">Electrical / Sensor</span>
        <div class="bar-bg"><div class="bar bar--blue" style="width: 100%"></div></div>
        <b>3,412</b>
      </div>
      <div class="fault-row">
        <span class="fault-label">Mechanical Jam</span>
        <div class="bar-bg"><div class="bar bar--blue" style="width: 82%"></div></div>
        <b>2,798</b>
      </div>
      <div class="fault-row">
        <span class="fault-label">PLC / Control</span>
        <div class="bar-bg"><div class="bar bar--blue" style="width: 64%"></div></div>
        <b>2,186</b>
      </div>
      <div class="fault-row">
        <span class="fault-label">Tooling Wear</span>
        <div class="bar-bg"><div class="bar bar--orange" style="width: 51%"></div></div>
        <b>1,742</b>
      </div>
      <div class="fault-row">
        <span class="fault-label">Hydraulic / Pneumatic</span>
        <div class="bar-bg"><div class="bar bar--orange" style="width: 39%"></div></div>
        <b>1,331</b>
      </div>
    </div>
  </article>

</section>
